import {
  ConfirmEmail,
  ResetPasswordRequest,
  User,
  UserRegister,
  UserUpdate,
} from 'src/app/models/user.model';
import { List } from 'src/app/models/list.model';

export class LoadUsers {
  static readonly type = '[Users] Load';
  constructor(
    public page: number,
    public pageSize: number,
    public sort: string,
    public sortDirection: string,
    public filters: string[]
  ) {}
}

export class LoadUsersSuccess {
  static readonly type = '[Users] Load Success';
  constructor(public list: List<User>) {}
}

export class LoadUsersFailure {
  static readonly type = '[Users] Load Failure';
  constructor(public error: any) {}
}

export class RegisterUser {
  static readonly type = '[Users] Register';
  constructor(public register: UserRegister) {}
}

export class RegisterUserSuccessAction {
  static readonly type = '[Users] Register Success';
}

export class RegisterUserFailureAction {
  static readonly type = '[Users] Register Failure';
  constructor(public error: any) {}
}

export class SetPasswordAction {
  static readonly type = '[Users] Set Password';
  constructor(
    public data: { email: string; token: string; password: string }
  ) {}
}

export class SetPasswordSuccessAction {
  static readonly type = '[Users] Set Password Success';
}

export class SetPasswordFailureAction {
  static readonly type = '[Users] Set Password Failure';
  constructor(public error: any) {}
}

export class ResetPasswordAction {
  static readonly type = '[Users] Reset Password';
  constructor(public data: { email: string }) {}
}

export class ResetPasswordSuccessAction {
  static readonly type = '[Users] Reset Password Success';
}

export class ResetPasswordFailureAction {
  static readonly type = '[Users] Reset Password Failure';
  constructor(public error: any) {}
}

export class ConfirmEmailAction {
  static readonly type = '[Users] Confirm Email';
  constructor(public data: { email: ConfirmEmail }) {}
}

export class ConfirmEmailSuccessAction {
  static readonly type = '[Users] Confirm Email Success';
}

export class ConfirmEmailFailureAction {
  static readonly type = '[Users] Confirm Email Failure';
  constructor(public error: any) {}
}

export class UpdateUserAction {
  static readonly type = '[Users] Update';
  constructor(public update: UserUpdate) {}
}

export class UpdateUserSuccessAction {
  static readonly type = '[Users] Update Success';
}

export class UpdateUserFailureAction {
  static readonly type = '[Users] Update Failure';
  constructor(public error: any) {}
}
